import * as React from "react";
import { Dropdown, Input, InputProps, makeStyles, Option } from "@fluentui/react-components";

interface SearchProps {
  query: string;
  setQuery: (query: string) => void;
  redactionQuery: string;
  setRedactionQuery: (query: string) => void;
  tags: string[];
  selectedTags: string[];
  setSelectedTags: (tags: string[]) => void;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  dropdown: {
    marginTop: ".5rem",
  },
});

export const Search = (props: SearchProps) => {
  const { query, setQuery, redactionQuery, setRedactionQuery } = props;
  const styles = useStyles();
  const [value, setValue] = React.useState<string>("");

  const onChange: InputProps["onChange"] = (_ev, data) => {
    setQuery(data?.value ?? "");
  };
  const onRedactionChange: InputProps["onChange"] = (_ev, data) => {
    setRedactionQuery(data?.value ?? "");
  };

  const onOptionSelect = (_ev, data) => {
    props.setSelectedTags(data.selectedOptions);
    setValue(data.optionText ?? "");
  };

  return (
    <div className={styles.root}>
      <Input id="search" appearance="outline" value={query} onChange={onChange} placeholder="Imię, Nazwisko" />
      <Input
        id="redaction"
        appearance="outline"
        value={redactionQuery}
        onChange={onRedactionChange}
        placeholder="Redakcja"
        className={styles.dropdown}
      />
      <Dropdown
        id={`tags`}
        className={styles.dropdown}
        value={value}
        selectedOptions={props.selectedTags}
        onOptionSelect={onOptionSelect}
        placeholder="Wybierz kategorię dystrybucyjną"
      >
        {props.tags.map((tag) => (
          <Option text={tag} value={tag} key={tag}>
            {tag}
          </Option>
        ))}
      </Dropdown>
    </div>
  );
};
